import React from 'react';
import propTypes from 'prop-types';
import { TextField } from 'formik-material-ui';
import { Field } from 'formik';
import * as Yup from 'yup';

export const type = "number";
export const defaultValue = 0;
export const schema = Yup.number().required('Required');

export default function OutputActivationThresholdField({ namespace, label, className, isSubmitting, ...props }) {

  return (
    <Field
      size='small'
      className={className}
      label={label}
      placeholder={label}
      component={TextField}
      name={namespace}
      type={type}
      disabled={isSubmitting}
      onClick={(ev) => ev.stopPropagation()}
    />
  );
}

OutputActivationThresholdField.propTypes = {
  namespace: propTypes.string,
  label: propTypes.string,
  className: propTypes.string,
  isSubmitting: propTypes.bool,
}
